export default "__VITE_ASSET__1G4gSvwM__"